import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd } from '@angular/router';

import { Article, ArticleService, Category } from './shared';

@Component({
  selector: 'bp-news',
  templateUrl: 'news.component.html'
})

export class NewsComponent implements OnInit, OnDestroy {

  categories: Category[] = [];
  filteredCategories = this.categories;
  routeEventSub: any;
  initSelection: number;
  private id: any;

  constructor(
    private articleService: ArticleService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.getCategories();

    this.routeEventSub = this.router.events
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
         // console.log('snapsot rute', this.route.snapshot)
          if (!this.route.snapshot.firstChild || !this.route.snapshot.firstChild.params['id']) {
            this.initSelection = this.categories && this.categories.length > 0 && this.categories[0].id;
            if (this.initSelection) {
              this.router.navigateByUrl(`/news/${this.initSelection}`);
            }
          }
        }
      });
  }

  ngOnDestroy(): void {
    if (this.routeEventSub != null) {
      this.routeEventSub.unsubscribe();
    }
  }

  getCategories() {
    this.categories = [];

    this.articleService.getCategories()
      .subscribe(categories => {
        this.categories = categories;

        if (!this.route.snapshot.firstChild || !this.route.snapshot.firstChild.params['id']) {
          this.initSelection = this.categories && this.categories.length > 0 && this.categories[0].id;
          if (this.initSelection) {
            this.router.navigateByUrl(`/news/${this.initSelection}`);
          }
        }
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/news/news.component.ts